<template>
  <div id="page-top">
    <div id="wrapper">
      <Navbar></Navbar>
      <div id="content-wrapper" class="d-flex flex-column">
        <div id="content">
          <Topbar></Topbar>
          <div class="container-fluid">
            <transition name="fade">
              <div id="preloader">
                <div data-loader="circle-side"></div>
              </div>
            </transition>
            <transition name="fade">
              <div id="loader_form">
                <div data-loader="circle-side-2"></div>
              </div>
            </transition>
            <div class="card shadow mb-4">
              <div class="card-header py-3 d-flex align-items-center justify-content-between">
                <h6 class="m-0 font-weight-bold text-dark">Business Units</h6>
                <button class="btn btn-sm btn-success shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#addModalUnit" v-bind:disabled="addUnitProcess || editUnitProcess || deleteUnitProcess"><i class="fas fa-plus fa-md"></i></button>
              </div>
              <div class="card-body">
                <transition name="fade">
                  <div v-if="messageAlert" class="alert p-3" v-bind:class="{ 'alert-success': isSuccess, 'alert-danger': isError }" role="alert">
                    {{messageAlert}}
                  </div>
                </transition>
                <div class="table-responsive">
                  <table class="table table-hover table-bordered" id="dataTableUnit" width="100%" cellspacing="0">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th class="d-none">Id</th>
                        <th>Nom</th>
                        <th class="text-center">Actions</th>
                      </tr>
                    </thead>
                    <tfoot>
                      <tr>
                        <th>#</th>
                        <th class="d-none">Id</th>
                        <th>Nom</th>
                        <th class="text-center">Actions</th>
                      </tr>
                    </tfoot>
                    <tbody>
                      <tr v-for="(item, index) in business_units" v-bind:key="item.id">
                        <td>{{index+1}}</td>
                        <td class="d-none">{{item.id}}</td>
                        <td>{{item.name}}</td>
                        <td class="text-center">
                          <button class="btn btn-sm btn-primary shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#viewModalUnit" v-on:click="viewUnit(item.id)" v-bind:disabled="addUnitProcess || editUnitProcess || deleteUnitProcess">
                          <i class="fas fa-eye fa-md"></i>
                          </button>
                          <button class="btn btn-sm btn-warning shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#editModalUnit" v-on:click="viewUnit(item.id)" v-bind:disabled="addUnitProcess || editUnitProcess || deleteUnitProcess">
                          <i class="fas fa-pencil-alt fa-md"></i>
                          </button>
                          <button class="btn btn-sm btn-danger shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#deleteModalUnit" v-on:click="viewUnit(item.id)" v-bind:disabled="addUnitProcess || editUnitProcess || deleteUnitProcess">
                          <i class="fas fa-trash fa-md"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </div>
    <a class="scroll-to-top rounded" href="#page-top">
    <i class="fas fa-angle-up"></i>
    </a>
    <!-- Add Modal Business Units -->
    <div class="modal fade" id="addModalUnit" tabindex="-1" role="dialog" aria-labelledby="ModalUnitLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <form id="addUnitForm" class="user" action="javascript:void(0);">
            <div class="modal-header">
              <h5 class="modal-title" id="ModalUnitLabel">Ajouter Business Units</h5>
              <button class="close" type="button" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-row">
                <div class="col-sm-12">
                  <label>Nom</label>
                  <input type="text" class="form-control mb-2" v-model="name1" name="name1" required>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-success text-uppercase w-50" href="javascript:(0)" v-on:click="addUnit" v-bind:disabled="addUnitProcess || editUnitProcess || deleteUnitProcess">
              <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="addUnitProcess">
              Ajouter
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- View Modal Business Units -->
    <div class="modal fade" id="viewModalUnit" tabindex="-1" role="dialog" aria-labelledby="ModalUnitLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalUnitLabel">Business Units [#<span>{{indexUnit+1}}</span>]</h5>
            <button class="close" type="button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <th scope="row">Id</th>
                  <td>{{id2}}</td>
                </tr>
                <tr>
                  <th scope="row">Nom</th>
                  <td>{{name2}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary text-uppercase w-50" href="javascript:(0)" data-dismiss="modal">
            Fermer</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Edit Modal Business Units -->
    <div class="modal fade" id="editModalUnit" tabindex="-1" role="dialog" aria-labelledby="ModalUnitLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <form id="editUnitForm" class="user" action="javascript:void(0);">
            <div class="modal-header">
              <h5 class="modal-title" id="ModalUnitLabel">Modifier Business Units [#<span>{{indexUnit+1}}</span>]</h5>
              <button class="close" type="button" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-row">
                <div class="col-sm-12">
                  <label>Nom</label>
                  <input type="text" class="form-control mb-2" v-model="name3" name="name3" required>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-warning text-uppercase w-50" href="javascript:(0)" v-on:click="editUnit" v-bind:disabled="addUnitProcess || editUnitProcess || deleteUnitProcess">
              <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="editUnitProcess">
              Modifier
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- delete Modal Business Units -->
    <div class="modal fade" id="deleteModalUnit" tabindex="-1" role="dialog" aria-labelledby="ModalUnitLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalUnitLabel">Supprimer Business Units [#<span>{{indexUnit+1}}</span>]</h5>
            <button class="close" type="button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="text-center text-uppercase mt-3">êtes-vous sûr de vouloir supprimer cette business unit ?</p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-danger text-uppercase w-50" href="javascript:(0)" v-on:click="deleteUnit" v-bind:disabled="addUnitProcess || editUnitProcess || deleteUnitProcess">
            <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="deleteUnitProcess">
            Supprimer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s
}
.fade-enter,
.fade-leave-to {
  opacity: 0
}
#preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  background-color: #fff;
  z-index: 999999;
}
[data-loader="circle-side"] {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  -webkit-animation: circle infinite .95s linear;
  -moz-animation: circle infinite .95s linear;
  -o-animation: circle infinite .95s linear;
  animation: circle infinite .95s linear;
  border: 2px solid #333;
  border-top-color: rgba(0, 0, 0, 0.2);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-radius: 100%;
}
#loader_form {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 999999;
  display: none;
}
[data-loader="circle-side-2"] {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  -webkit-animation: circle infinite .95s linear;
  -moz-animation: circle infinite .95s linear;
  -o-animation: circle infinite .95s linear;
  animation: circle infinite .95s linear;
  border: 2px solid #333;
  border-top-color: rgba(0, 0, 0, 0.2);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-radius: 100%;
}
@-webkit-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-moz-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-o-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>

<script>
import Navbar from './Navbar'
import Topbar from './Topbar'
import Footer from './Footer'
import axios from 'axios'
$.fn.isValid = function () {
  return this[0].checkValidity()
}
export default {
  name: 'App',
  components: {
    'Topbar': Topbar,
    'Navbar': Navbar,
    'Footer': Footer
  },
  data () {
    return {
      loading: true,
      progress: 0,
      activity: {},
      indexUnit: '',
      business_units: [],
      isSuccess: true,
      isError: false,
      messageAlert: '',
      addUnitProcess: false,
      viewUnitProcess: false,
      editUnitProcess: false,
      deleteUnitProcess: false,
      name1: '',
      id2: '',
      name2: '',
      name3: '',
      dTableUnit: ''
    }
  },
  methods: {
    //Initialiser variables et tables
    init () {
      setTimeout(() => {
        this.dTableUnit = $('#dataTableUnit').DataTable({
          'columns': [
            { 'width': '15' },
            null,
            null,
            { 'width': '100' }
          ],
          'lengthMenu': [
            [10],
            [10]
          ],
          order: [
            [0, 'desc']
          ],
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true
        })
        this.activity = {
          'id': '',
          'name': ''
        }
        this.name1 = ''
        this.id2 = ''
        this.name2 = ''
        this.name3 = ''
      }, 50)
    },
    //Sélectionner toutes les Business Unitss (Base de données)
    getBusinessUnits () {
      axios.get(this.apiUrl+'/business_units', {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          this.business_units = res.data
          this.progress += 1
          if (this.progress === 1) this.loading = false
        }).catch(err => {
          console.log(err)
        })
    },
    //Ajouter une Business Units
    addUnit () {
      if ($('#addUnitForm').isValid()) {
        this.addUnitProcess = true
        let activity = {
          id: this.business_units.length + 1,
          name: this.name1,
        }
        axios.post(this.apiUrl+'/business_units', activity, {headers: {'Authorization': `Bearer ${this.token}`}}).then(res => {
          if (res.status == 201) {
            this.isSuccess = true
            this.isError = false
            this.messageAlert = 'enregistrement ajouté avec succès'
            this.business_units.push(activity)
            this.dTableUnit.destroy()
            this.init()
          }
          $('#addModalUnit').modal('hide')
          this.addUnitProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        }).catch(err => {
          console.log(err)
          this.isError = true
          this.isSuccess = false
          this.messageAlert = err
          $('#addModalUnit').modal('hide')
          this.addUnitProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        })
      }
    },
    //Sélectionner une Business Units (Local)
    viewUnit (id) {
      this.activity = this.business_units.filter(function (item) {
        return item.id === id
      })[0]
      this.indexUnit = this.business_units.indexOf(this.activity)
      this.id2 = this.activity.id
      this.name2 = this.activity.name
      this.name3 = this.activity.name
    },
    //Modifier une Business Units
    editUnit () {
      if ($('#editUnitForm').isValid()) {
        var id = this.activity.id
        this.editUnitProcess = true
        axios.put(this.apiUrl+'/business_units/' + id, {
          name: this.name3
        }, {headers: {'Authorization': `Bearer ${this.token}`}}).then(res => {
          if (res.status == 200) {
            this.isSuccess = true
            this.isError = false
            this.messageAlert = 'enregistrement modifié avec succès'
            this.activity.name = this.name3
            this.business_units[this.indexUnit] = this.activity
            this.dTableUnit.destroy()
            this.init()
          }
          $('#editModalUnit').modal('hide')
          this.editUnitProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        }).catch(err => {
          console.log(err)
          this.isError = true
          this.isSuccess = false
          this.messageAlert = err
          $('#editModalUnit').modal('hide')
          this.editUnitProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        })
      }
    },
    //Supprimer une Business Units
    deleteUnit () {
      var id = this.activity.id
      this.deleteUnitProcess = true
      axios.delete(this.apiUrl+'/business_units/' + id, {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          if (res.status == 200) {
            this.isSuccess = true
            this.isError = false
            this.messageAlert = 'enregistrement supprimé avec succès'
            this.business_units.splice(this.indexUnit, 1)
            this.dTableUnit.destroy()
            this.init()
          }
          $('#deleteModalUnit').modal('hide')
          this.deleteUnitProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        }).catch(err => {
          console.log(err)
          this.isError = true
          this.isSuccess = false
          this.messageAlert = err
          $('#deleteModalUnit').modal('hide')
          this.deleteUnitProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        })
    }
  },
  created () {
    $('body').css({'overflow': 'hidden'})
    this.getBusinessUnits()
  },
  watch: {
    loading: function () {
      this.init()
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      $('[data-loader="circle-side"]').fadeOut()
      $('#preloader').delay(350).fadeOut('slow')
      $('body').delay(350).css({
        'overflow': 'auto'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Business.vue